export const RADIUS: string = "R";
export const INNER_RADIUS: string = "I";
export const CLIP: string = "C";
export const RECESSED_DIAGONAL: string = "RD";
export const DIAGONAL: string = "D";
export const BUMPOUT = "B";
export const NOTCH = "N";
export const STANDARD = "S";